<template>
    <div v-if="showHelpText" class="help-area">
        <div class="commodity-grid">
            <div v-for="item in shoppingCommodities" :key="item.id">
                <Commodity :item="item"/>
            </div>
        </div>

        <div class="help-grid">
            <div>空格: 暂停/播放</div>
            <div>Q: 全屏/退出全屏</div>
            <div>A: 后退一帧</div>
            <div>D: 前进一帧</div>
            <div>W: 加速播放</div>
            <div>S: 减速播放</div>
            <div>R: 重播</div>
            <div>F: 和订单一致</div>
            <div>J: 和订单一致</div>
            <div>鼠标滚轮上：后退一帧</div>
            <div>鼠标滚轮下：前进一帧</div>
        </div>
    </div>
</template>

<script>
import Vue from 'vue';
import Commodity from "./Commodity.vue";
import { mapGetters } from 'vuex';

export default {
    name: 'HelpArea',
    props: {},
    components: {
        Commodity
    },
    computed: {
        ...mapGetters([
            "showHelpText", // 通过 getter 获取是否显示帮助文本
            "shoppingCommodities" // 通过 getter 获取购物商品
        ])
    },
    methods: {}
}
</script>

<style scoped>
.help-area {
    width: 100%;
    padding: 10px;
    color: #AAA;
    z-index: 5;
}

.commodity-grid {
    display: flex;
    flex-wrap: wrap; /* 允许换行 */
    margin-top: 10px;
    margin-bottom: 10px;
    padding: 5px;
    background: lightgray;
    justify-content: flex-start; /* 从左侧开始排列 */
}

.commodity-grid > div {
    flex: 0 1 20px;
    margin: 5px; 
}




.help-grid {
    font-size: 12px;
    display: flex;
    flex-wrap: wrap; /* 使元素换行 */
    gap: 20px; /* 每个元素之间的间距 */
    margin-left: 5px;
    margin-bottom: 10px;
}

.help-grid > div {
    text-align: left;
    white-space: nowrap; /* 防止文字换行 */
}
</style>
